import Grid from "@material-ui/core/Grid";
import { LcmModel } from "../../domain/LcmModel";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { fieldLabels } from "./fieldlabels";
import { MarkdownEditor } from "@ofqual/portal-components/components/MarkdownEditor";
import { Error } from "../common/Error";
import { nameof } from "ts-simple-nameof";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { SearchField } from "../components/SearchField";
import { useMemo } from "react";
import { keywordService } from "../../services";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { useSelector } from "react-redux";
import { authSelector } from "../../redux/selectors";

export const TaggingSection: React.FC<{
  sectionProps: SectionProps<LcmModel>;
}> = ({ sectionProps }) => {
  const { control, disabled, lookupTracker, errors } = sectionProps;
  const { token } = useSelector(authSelector);

  const mappedKeywordLookupService = useMemo(
    () => ({
      get: (id: string) => keywordService.get(id.toString(), { token }),
      search: (params?: QueryParams) =>
        keywordService.search(params || {}, { token }),
    }),
    [token]
  );

  const mappedAddKeyWordService = useMemo(
    () => ({
      add: (keyword: string) =>
        keywordService.add(keyword, { token }),
    }),
    [token]
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          rules={{ maxLength: 5000 }}
          name={nameof<LcmModel>((x) => x.taggingSummary)}
          render={({ onChange, value }) => (
            <>
              <label>{fieldLabels.taggingSummary}</label>
              <MarkdownEditor
                onChange={onChange}
                value={value}
                readOnly={disabled}
                dataTest="tagging-summary-field"
              />
            </>
          )}
        />
        {errors.taggingSummary?.type === "maxLength" && (
          <Error data-test="summary-length-validation">
            Max length exceeded
          </Error>
        )}
      </Grid>

      <Grid item xs={12} md={12} lg={12} xl={12}>
        <Controller
          control={control}
          name={nameof<LcmModel>((x) => x.taggingReceivedFrom)}
          as={
            <TextField
              label={fieldLabels.taggingReceivedFrom}
              data-test="tagging-received-from-field"
              fullWidth
              readOnly={disabled}
            />
          }
        />
      </Grid>

      <Grid item xs={12} md={12} lg={12} xl={12}>
        <Controller
          control={control}
          name={nameof<LcmModel>((x) => x.keywordId)}
          as={
            <SearchField
              searchFieldVariant="multiple"
              label={fieldLabels.taggingKeywords}
              datatest="advice-keywords-field"
              service={mappedKeywordLookupService}
              addservice={mappedAddKeyWordService}
              disabled={disabled}
              lookupTracker={lookupTracker}
            />
          }
        />
      </Grid>
    </Grid>
  );
};
